import { TOGGLE_CENTRAL_PAYMENT } from "../actions/CentralPaymentAction";

export const getInitialState = () => ({
    useCentralPayment: true, // 預設
    modalOpen: false,
    modalType: null,
});

const CentralPaymentReducer = (state = getInitialState(), action) => {
    switch (action.type) {
        case TOGGLE_CENTRAL_PAYMENT:
            // 如果新值與當前值相同，直接返回當前 state 避免不必要的更新
            if (state.useCentralPayment === action.payload) {
                return state;
            }
            return { ...state, useCentralPayment: action.payload };
        case "OPEN_CP_MODAL":
            console.log(
                "{ ...state, modalOpen: true, modalType: action.payload } :",
                { ...state, modalOpen: true, modalType: action.payload }
            );
            return { ...state, modalOpen: true, modalType: action.payload };
        case "CLOSE_CP_MODAL":
            return { ...state, modalOpen: false, modalType: null };
        default:
            return state;
    }
};

export default CentralPaymentReducer;
